export default __webpack_public_path__ + "static/media/Hearts Valentine_s wreath.f9d72c86.jpg";